/**
 * Copies text to the clipboard. Requires a secure context (localhost is fine).
 */
export async function copyText(text: string): Promise<void> {
  await navigator.clipboard.writeText(text);
}
